var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.66673L4.96944 8.81343C5.02042 8.87222 5.08433 8.91944 5.15657 8.9517C5.22882 8.98396 5.30761 9.00045 5.38729 8.99999C5.46697 8.99953 5.54555 8.98213 5.61739 8.94905C5.68923 8.91596 5.75254 8.86801 5.80278 8.80863L9 5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgTick;